"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./KYCSettingsComponent.css");
require("./KYCFormSidePaneComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYCSettingsComponent = function KYCSettingsComponent(props) {
  var LevelsComponent = props.LevelsComponent;
  return /*#__PURE__*/_react["default"].createElement(LevelsComponent, null);
};
var _default = exports["default"] = KYCSettingsComponent;